import { Typography } from "@circle-react-shared/uikit/Typography";

interface TitleAndSubtitleProps {
  subtitle: string;
  title: string;
}

export const TitleAndSubtitle = ({
  title,
  subtitle,
}: TitleAndSubtitleProps) => (
  <div className="flex flex-col gap-y-0.5">
    <Typography.LabelSm weight="medium" color="text-darkest">
      {title}
    </Typography.LabelSm>
    <Typography.BodySm weight="normal" color="text-default">
      {subtitle}
    </Typography.BodySm>
  </div>
);
